<template>
  <el-dialog
    :visible.sync="visibleProxy"
    title="Thêm số lượng học sinh"
    width="520px"
    :close-on-click-modal="false"
    append-to-body
    custom-class="ps-dialog"
  >
    <div v-if="schoolRow" class="ps-addon-summary">
      <div>
        <span class="ps-addon-summary__label">Trường</span>
        <strong>{{ schoolRow.school.name }}</strong>
      </div>
      <div class="ps-addon-summary__numbers">
        <span>Đang dùng <b>{{ schoolRow.currentStudents | formatNumber }}</b></span>
        <span>Giới hạn hiện tại <b>{{ schoolRow.effectiveLimit | formatNumber }}</b></span>
      </div>
    </div>

    <el-form ref="addonForm" :model="form" :rules="rules" label-position="top" class="ps-dialog-form">
      <el-form-item label="Số lượng thêm" prop="amount" required>
        <el-input-number
          v-model="form.amount"
          :min="1"
          :max="100000"
          controls-position="right"
          class="ps-full-width"
        />
      </el-form-item>
      <el-form-item label="Lý do thêm số lượng" prop="note" required>
        <el-input
          v-model="form.note"
          type="textarea"
          :rows="3"
          maxlength="500"
          show-word-limit
          placeholder="Nhập lý do thêm số lượng"
        />
      </el-form-item>
    </el-form>

    <div v-if="schoolRow" class="ps-addon-after">
      <div>
        <span>Giới hạn hiệu lực sau khi thêm</span>
        <b>{{ afterLimit | formatNumber }}</b>
      </div>
      <div>
        <span>Tỷ lệ sử dụng mới</span>
        <b :class="afterUsage >= 100 ? 'is-danger' : 'is-success'">{{ afterUsage | percent }}%</b>
      </div>
    </div>

    <span slot="footer" class="ps-dialog-footer">
      <el-button @click="visibleProxy = false">Hủy</el-button>
      <el-button type="primary" :loading="saving" @click="handleConfirm">
        <i class="el-icon-plus" /> Thêm {{ form.amount || 0 }} vào giới hạn số lượng
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "AddonDialog",
  filters: {
    percent(value) {
      return Number(value || 0).toFixed(1);
    },
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    schoolRow: {
      type: Object,
      default: null,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: { amount: 10, note: "" },
      rules: {
        amount: [{ validator: (rule, value, callback) => {
          if (!Number.isInteger(value) || value <= 0) {
            callback(new Error("Số lượng thêm phải là số nguyên dương"));
            return;
          }
          callback();
        }, trigger: "change" }],
        note: [{ validator: (rule, value, callback) => {
          if (!String(value || "").trim()) {
            callback(new Error("Vui lòng nhập lý do thêm số lượng"));
            return;
          }
          callback();
        }, trigger: "blur" }],
      },
    };
  },
  computed: {
    visibleProxy: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
    afterLimit() {
      return this.schoolRow ? this.schoolRow.effectiveLimit + Number(this.form.amount || 0) : 0;
    },
    afterUsage() {
      return this.afterLimit ? (this.schoolRow.currentStudents / this.afterLimit) * 100 : 0;
    },
  },
  watch: {
    visible(value) {
      if (value) {
        this.form = { amount: 10, note: "" };
        this.$nextTick(() => {
          if (this.$refs.addonForm) {
            this.$refs.addonForm.clearValidate();
          }
        });
      }
    },
  },
  methods: {
    handleConfirm() {
      this.$refs.addonForm.validate((valid) => {
        if (valid && this.schoolRow && this.schoolRow.assignment) {
          this.$emit("submit", {
            schoolPackageId: this.schoolRow.assignment.id,
            amount: this.form.amount,
            note: String(this.form.note || "").trim(),
          });
        }
      });
    },
  },
};
</script>
